<template>
    <form @submit.prevent="submit">
        <button
            type="submit"
            data-cy="logout-button"
            v-bind="$attrs"
        >
            {{ $t('navigation.signOut') }}
        </button>
    </form>
</template>

<script setup lang="ts">
import { logout } from '@/composables/useAuth';
import { flashStore } from '@/store';
import { useRouter } from 'vue-router';

const router = useRouter();

defineOptions({ inheritAttrs: false });

const submit = async () => {
    const response = await logout();

    if (!response.ok) {
        const jsonResponse = await response.json();
        return flashStore.doFlash({
            message: jsonResponse.message,
            level: 'error'
        });
    }

    return router.push({ name: 'home' });
};
</script>
